export type FaqItem = {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Otro PDF más que no voy a leer?',
    answer:
      'No es un libro para leer de corrido: es un sistema de consulta. Abres el tomo que resuelve el problema de hoy y usas la herramienta que necesitas ahora — el checklist del salón antes de la visita, el kit de mensajes antes de escribirle a un proveedor, el minuto a minuto la semana del evento. Es una caja de herramientas, no una lectura pendiente.',
  },
  {
    question: 'Yo aprendí sola y me va bien, ¿para qué pagar 13,90 dólares?',
    answer:
      'Porque el talento ya lo tienes: eso no se compra ni se enseña. Lo que te falta es la estructura que convierte ese talento en precios más altos y en noches tranquilas. El talento sin sistema tiene techo, y ese techo se llama "lo que puedo cobrar hoy".',
  },
  {
    question: '¿Sirve en mi país?',
    answer:
      'Sí. Cambian las monedas, los proveedores y los nombres de las cosas; los procesos no. Presupuestar, contratar, coordinar un montaje y manejar una crisis funcionan igual en México, Argentina, Colombia, España o Estados Unidos. Los porcentajes y las estructuras se ajustan a tu mercado sin perder la lógica.',
  },
  {
    question: '¿Es para principiantes o para las que ya trabajan?',
    answer:
      'Para las dos. Si estás empezando, es la infraestructura que nadie te enseña y que normalmente se aprende perdiendo plata. Si ya organizas fiestas, es la forma de profesionalizar, sistematizar y por fin subir tus precios con argumentos.',
  },
  {
    question: '¿Cómo lo recibo?',
    answer:
      'Descarga inmediata en PDF después del pago. Lo abres en cualquier dispositivo e imprimes lo que necesites llevar al salón.',
  },
  {
    question: '¿Puedo usar las plantillas con mi propia marca?',
    answer:
      'Sí. Los materiales que se presentan al cliente están pensados para que les pongas tu logo y los uses directamente con las familias.',
  },
  {
    question: 'No tengo tarjeta internacional / el dólar está imposible.',
    answer:
      'El pago se procesa en tu moneda local y con los medios de pago de tu país. Ves el monto exacto antes de confirmar.',
  },
  {
    question: '¿Y si no es para mí?',
    answer:
      'Garantía de 7 días con devolución del 100%, sin preguntas.',
  },
]
